import { gql } from '@apollo/client';

const GET_ORG_REPORT = gql`
  query GetOrganizationAppraisalReport(
    $orgUnitId: Int!
    $appraisalViewRequest: [AppraisalViewRequest]
  ) {
    organizationAppraisalReport(
      orgUnitId: $orgUnitId
      appraisalViewRequest: $appraisalViewRequest
    ) {
      PracticeAreas {
        Ids
        Name
        Acronym
        AggregatePercentageExact
        AggregatePercentage {
          Name
          Results
          Cnt
        }
        DefaultLevel
        Year
        Practices {
          Level
          NumberInLevel
          PracticeName
          Name
          Satisfied
          Partial
          Deficient
          Evaluation
        }
      }
    }
  }
`;

export default GET_ORG_REPORT;
